import { render, staticRenderFns } from "./UserEditPassword.vue?vue&type=template&id=70b0a4e8&"
import script from "./UserEditPassword.vue?vue&type=script&lang=js&"
export * from "./UserEditPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports